import {
    getPlace,
    getStart,
    getEnd,
    getBounds,
} from './searchLenses'

import {
    DEFAULT_AIRPORT_SEARCH_RADIUS,
    DEFAULT_PLACE_SEARCH_RADIUS,
} from 'commons/js/constants'

import {
    compactObject,
} from 'commons/js/util/objectUtils'

export default function mapSearchParams (search) {
    return compactObject({
        radius: getPlace(search).airport_id
            ? DEFAULT_AIRPORT_SEARCH_RADIUS
            : DEFAULT_PLACE_SEARCH_RADIUS,
        latitude: getPlace(search).latitude,
        longitude: getPlace(search).longitude,
        start: getStart(search),
        end: getEnd(search),
        ...getBounds(search),
    })
}
